import { useWizardListener } from '@mwkt/react-magic-frame';

import { MagicFrameWizardEvent } from '../constants';
import { useNavigation } from '../navigation';

const useWizardSetRestrictedPathsListener = () => {
  const { setRestrictedPaths } = useNavigation();

  useWizardListener({ event: MagicFrameWizardEvent.SetRestrictedPaths, callback: (restrictedPaths: string[]) => {
    setRestrictedPaths(restrictedPaths);
  } });
};

export default useWizardSetRestrictedPathsListener;
